<template>
  <el-aside id="aside" class="aside" :width="`${isCollapse ? '35' : '210'}px`">
  <!-- <el-aside id="aside" class="aside" :width="`${isCollapse ? '210' : '210'}px`"> -->
    <div v-if="true" style="overflow: auto;">
      <div class="search">
        <img src="./image/serchun.png" alt="">
        <el-input
          v-model="resourceName"
          class="sre_input"
          clearable
          size="mini"
          @change="serchMenuName"
          placeholder="请输入关键词"
        ></el-input>
      </div>
      <div
        @click="selectionCon(tab, index)"
        :class="{ menu_content: true, menuHover: tab.isSelect }"
        v-for="(tab, index) in routersList"
        :key="tab.path"
      >
        <div class="mc_left">
          <img
            class="mr-10 menu_icon"
            :src="bingIcon(tab.icon)"
            alt=""
            srcset=""
          />
          <span slot="title" style="font-size: 16px">{{ tab.name }}</span>
        </div>
        <img
          v-if="!tab.isSelect"
          class="mr-10 menu_icon"
          src="./image/nosect.png"
          alt=""
          srcset=""
        />
        <img
          v-else
          class="mr-10 menu_icon"
          src="./image/selct.png"
          alt=""
          srcset=""
        />
      </div>
      <div
        v-if="isSelect"
        class="broadsideContent"
        :style="{ left: `${isMove? '0' : '210'}px` }"
      >
       <div class="bb_stiky">
        <div class="back_buttom" @click="closeNmae">
          <img v-if="!isMove" src="./image/back.png" alt="" />
          <img v-else src="./image/commom.png" alt="" />
          {{ secondroutersName }}
        </div>
       </div>
        <div
          class="two_content"
          v-for="item in secondroutersList"
          :key="item.id"
        >
          <div
            @click="routerSecondLinks(item)"
            :class="{
              secondnamhh: true,
              thisirdandSECONDAction: selectPathUrl === item.path,
            }"
          >
            {{ item.name }}
          </div>
          <div
            :class="{
              thirdStyl: true,
              thisirdAction: selectPathUrl === chiitem.resourceUrl,
            }"
            v-for="chiitem in item.children"
            :key="chiitem.id+'cd'"
          >
            <div @click="routerLinks(chiitem.resourceUrl)">
              {{ chiitem.resourceName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-menu
      v-if="false"
      :collapse="isCollapse"
      :default-active="defaultActive"
      :default-openeds="defaultOpeneds"
      :unique-opened="true"
      background-color="#273655"
      text-color="#C2C6CD"
      active-text-color="#ffffff"
    >
      <div v-for="tab in routersList" :key="tab.path">
        <el-menu-item
          v-if="tab.type === 'menu-item'"
          :index="tab.path"
          @click="tab.method || routerLinks(tab.path)"
        >
          <!-- <img class="mr-10 menu_icon" :src="bingActiveIcon(tab.icon)"  v-if="$route.path == tab.path"  /> -->
          <img
            class="mr-10 menu_icon"
            :src="bingIcon(tab.icon)"
            alt=""
            srcset=""
          />
          <span slot="title" style="font-size: 16px">{{ tab.name }}</span>
        </el-menu-item>

        <el-submenu v-if="tab.type === 'submenu'" :index="tab.path">
          <template slot="title">
            <img
              class="mr-10 menu_icon"
              :src="bingIcon(tab.icon)"
              alt=""
              srcset=""
            />
            <span v-show="!isCollapse" slot="title">{{ tab.name }}</span>
          </template>
          <div v-for="item in tab.children" :key="item.path">
            <el-menu-item
              v-if="!item.method"
              :index="item.path"
              @click="routerLinks(item.path)"
            >
              {{ item.name }}
            </el-menu-item>
            <!--使用三目运算不能正常触发method，改成if-->
            <el-menu-item v-else :index="item.path" @click="item.method">
              {{ item.name }}
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </el-menu>
  </el-aside>
</template>

<script>
import { httpdata } from "./linshi";
import _api from "@/utils/request";
export default {
  name: "Aside",
  data() {
    return {
      resourceName: "",
      /*
       * type: 'menu-item'(单个菜单)、'submenu'(菜单组)
       * */
      // routersList: [
      //   {
      //     path: "/dashboard",
      //     type: "menu-item",
      //     icon: "el-icon-s-home",
      //     name: "首页",
      //   },
      //   {
      //     type: "submenu",
      //     path: "/merchant",
      //     icon: "el-icon-picture-outline-round",
      //     name: "第三方回收商",
      //     children: [
      //       {
      //         path: "/merchant/list",
      //         name: "商家列表",
      //       },
      //       {
      //         path: "/merchant/apply",
      //         name: "入驻申请",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/oldBrand",
      //     icon: "el-icon-picture-outline-round",
      //     name: "品牌&机型",
      //     children: [
      //       {
      //         path: "/oldBrand/Resident",
      //         name: "品牌管理",
      //       },
      //       {
      //         path: "/oldBrand/Model",
      //         name: "机型管理",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/classification",
      //     icon: "el-icon-picture-outline-round",
      //     name: "回收分类管理",
      //     children: [
      //       {
      //         path: "/classification/ClassList",
      //         name: "分类列表",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/caseFailure",
      //     icon: "el-icon-picture-outline-round",
      //     name: "报价配置信息",
      //     children: [
      //       {
      //         path: "/caseFailure/caseImg",
      //         name: "旧机示例图",
      //       },
      //       {
      //         path: "/caseFailure/failure",
      //         name: "快捷备注",
      //       },
      //       {
      //         path: "/caseFailure/coreFailure",
      //         name: "核心故障",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/RecallOrder",
      //     icon: "el-icon-picture-outline-round",
      //     name: "回收订单管理",
      //     children: [
      //       {
      //         path: "/RecallOrder/index",
      //         name: "订单列表",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/systemManage",
      //     icon: "el-icon-picture-outline-round",
      //     name: "系统管理",
      //     children: [
      //       {
      //         path: "/systemManage/RolePurview",
      //         name: "角色权限",
      //       },
      //       {
      //         path: "/systemManage/StaffManage",
      //         name: "职员管理",
      //       },
      //       {
      //         path: "/systemManage/Resources",
      //         name: "资源配置",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/Feedback",
      //     icon: "el-icon-picture-outline-round",
      //     name: "意见反馈",
      //     children: [
      //       {
      //         path: "/Feedback/index",
      //         name: "意见反馈",
      //       },
      //     ],
      //   },

      //   {
      //     type: "submenu",
      //     path: "/SystemOffer",
      //     icon: "el-icon-picture-outline-round",
      //     name: "系统报价回收",
      //     children: [
      //       {
      //         path: "/SystemOffer/list",
      //         name: "商家列表",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/StoreShop",
      //     icon: "el-icon-picture-outline-round",
      //     name: "门店商家",
      //     children: [
      //       {
      //         path: "/StoreShop/index",
      //         name: "商家列表",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/qrcode",
      //     icon: "el-icon-picture-outline-round",
      //     name: "二维码管理",
      //     children: [
      //       {
      //         path: "/qrcode/CreatDistribute",
      //         name: "二维码生成&分配",
      //       },
      //       {
      //         path: "/qrcode/MerchantsQrcode",
      //         name: "门店商家二维码",
      //       },
      //       {
      //         path: "/qrcode/QrcodeSearch",
      //         name: "二维码查询",
      //       },
      //       {
      //         path: "/qrcode/QrcodeDelivery",
      //         name: "二维码发货",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/payment",
      //     icon: "el-icon-picture-outline-round",
      //     name: "支付管理",
      //     children: [
      //       {
      //         path: "/payment/PaymentSet",
      //         name: "支付设置",
      //       },
      //       {
      //         path: "/payment/BillList",
      //         name: "充值订单",
      //       },
      //     ],
      //   },
      //   {
      //     type: "submenu",
      //     path: "/DemoVideo",
      //     icon: "el-icon-picture-outline-round",
      //     name: "演示视频",
      //     children: [
      //       {
      //         path: "/DemoVideo/list",
      //         name: "视频配置",
      //       },
      //       // {
      //       //   path: '/DemoVideo/add',
      //       //   name: '详情'
      //       // }
      //     ],
      //   },
      // ],
      selectPathUrl: null,
      isSelect: false,
      isMove: false,
      routersList: [],
      secondroutersName: "",
      secondroutersList: [],
      defaultActive: this.activeTab,
      defaultOpeneds: [],
      firstPathUrl:'/dashboard'
    };
  },
  created() {
    // console.log(httpdata);

    this.getMenuList();
  },
  mounted() {
    const path = this.$route.path;
    // console.log(path);
    if (path.indexOf("/feature/TabsView") === -1) {
      this.defaultActive = path;
    } else {
      this.defaultActive = "/feature/TabsView";
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.tagsView.isCollapse;
    },
    routerPath() {
      return this.$store.state.tagsView.routerPath;
    },
  },
  watch: {
    routerPath(path) {
      console.log(path);
      if (path.indexOf("/feature/TabsView") === -1) {
        this.defaultActive = path;
      } else {
        this.defaultActive = "/feature/TabsView";
      }
    },
    isCollapse(val){
      console.log(val,"收齐操作");
      if(val){
        this.isSelect=false
      }else{
        if(this.firstPathUrl=='/dashboard'){
          this.isSelect=false
        }else{
          this.isSelect=true
        }
      }
    }
  },
  methods: {
    serchMenuName(e){
      console.log(e,"搜索记录");
      this.resourceName=e
      this.selectPathUrl=null
      this.isSelect=false
      this.getMenuList();
    },
    closeNmae() {
      this.isMove = !this.isMove;
    },
    selectionCon(tab, index) {
      console.log(tab);
      this.firstPathUrl=tab.path
      this.selectPathUrl = null;
      this.isMove = false;
      this.$store.commit('tagsView/SET_ISCOLLAPSE', false)
      if (tab.children.length == 0) {
        this.isSelect = false;
        this.$nextTick(() => {
          this.routersList.forEach((item) => {
            if (item.path == tab.path) {
              item.isSelect = true;
            } else {
              item.isSelect = false;
            }
          });
          this.$forceUpdate();
        });
        if (this.$route.path !== tab.path) {
          this.$router.push(tab.path);
        }
      } else {
        this.$nextTick(() => {
          this.routersList.forEach((item) => {
            if (item.path == tab.path) {
              item.isSelect = true;
            } else {
              item.isSelect = false;
            }
          });
          this.isSelect = true;
          this.secondroutersName = this.routersList[index].name;
          this.secondroutersList = this.routersList[index].children;
          console.log(this.secondroutersList);
          this.$forceUpdate();
        });
      }
    },
    bingIcon(icon) {
      icon = icon || "default";
      let reg = icon.indexOf("http");
      return reg >= 0 ? icon : require(`@/assets/menu/${icon}.png`);
    },
    bingActiveIcon(icon) {
      icon = icon || "default";
      let reg = icon.indexOf("http");
      return reg >= 0 ? icon : require(`@/assets/menu/${icon}_hover.png`);
    },
    routerLinks(path) {
      console.log(path);
      this.selectPathUrl = path;
      this.isMove = true;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    routerSecondLinks(data) {
      console.log(data, this.$route.path, data.path);
      this.isMove = true;
      if (this.$route.path !== data.path && data.children.length === 0) {
        console.log("ksahkjsgjk99997777");
        this.selectPathUrl = data.path;
        this.$router.push(data.path);
      }
    },
    getMenuList() {
      _api.getMenuList({
        resourceName:this.resourceName
      }).then((res) => {
        this.$store.commit("tagsView/MENU_LIST", res.data);
        res.data.forEach((item) => {
          item.name = item.resourceName;
          item.path = item.resourceUrl;
          if (item.children && item.children.length != 0) {
            item.type = "submenu";
            item.children.forEach((ele) => {
              ele.name = ele.resourceName;
              ele.path = ele.resourceUrl;
            });
          } else {
            item.type = "menu-item";
          }
        });
        console.log(res.data);
        this.routersList = res.data;
      });
      // let copydata = JSON.parse(JSON.stringify(httpdata));
      // let arrruter = copydata;
      // this.$store.commit("tagsView/MENU_LIST", arrruter);
      // arrruter.forEach((item) => {
      //   item.name = item.resourceName;
      //   item.path = item.resourceUrl;
      //   item.isSelect = false;
      //   if (item.children && item.children.length != 0) {
      //     item.type = "submenu";
      //     item.children.forEach((ele) => {
      //       ele.name = ele.resourceName;
      //       ele.path = ele.resourceUrl;
      //     });
      //   } else {
      //     item.type = "menu-item";
      //   }
      // });
      // console.log(arrruter);
      // this.routersList = arrruter;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.search {
  display: flex;
  align-items: center;
  padding: 0 10px;
  margin-left: 10px;
  width: 190px;
  height: 30px;
  margin-bottom: 15px;
  background: #484858;
  border-radius: 15px;
  /deep/.el-input__inner {
    border: none !important;
    width: 165px !important;
    height: 30px !important;
    background: #484858;
    border-radius: 15px !important;
    color: #ffffff !important;
    padding: 0 10px;
  }
  img{
    width: 12px;
    height: 12px;
  }
}

.two_content {
  padding: 0 0 0 8px;
  margin: 15px 0;
}
.bb_stiky{
  padding: 1px;
  position: sticky;
  top: 0px;
  background: #FFFFFF;
}
.back_buttom {
  cursor: pointer;
  margin-top: 15px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  color: #ffffff;
  width: 190px;
  height: 34px;
  background: linear-gradient(90deg, #0981ff 0%, #c7e2ff 100%);
  border-radius: 6px;
  img {
    width: 14px;
    height: 14px;
    margin-right: 10px;
  }
}
.secondnamhh {
  line-height: 28px;
  height: 28px;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  color: #294461;
}
.thirdStyl {
  min-width: 170px;
  // height: 28px;
  border-radius: 5px;
  line-height: 28px;
  cursor: pointer;
  margin: 5px 0;
  padding-left: 6px;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
}
// .thirdStyl:hover {
//   background: #e5f3fe;
//   border-radius: 5px;
//   color: #0981ff;
// }
.thisirdAction {
  background: #e5f3fe;
  border-radius: 5px;
  color: #0981ff;
}
.thisirdandSECONDAction {
  padding-left: 10px;
  position: relative;
  left: -10px;
  background: #e5f3fe;
  border-radius: 5px;
  color: #0981ff;
}
.menu_content {
  cursor: pointer;
  padding-left: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px auto;
  width: 190px;
  height: 40px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}
// .menu_content:hover {
//   background: linear-gradient(90deg, #0981ff 0%, #c7e2ff 100%);
// }
.menuHover {
  background: linear-gradient(90deg, #0981ff 0%, #c7e2ff 100%);
}
.mc_left{
  width: 153px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical
}
.broadsideContent {
  overflow: auto;
  transition: left 0.5s ease-in-out; /* 平滑滑动效果 */
  padding: 0 10px;
  top: 50px;
  z-index: 999;
  position: fixed;
  width: 210px;
  height: calc(100vh - 50px);
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 4px 6px 12px 0px rgba(0, 0, 0, 0.2);
}
.aside {
  padding-top: 15px;
  background: #202033;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  transition: width 0.3s;
}
.mr-10 {
  margin-right: 10px;
}
.menu_icon {
  width: 16px;
  height: 16px;
}
.dis {
  display: flex;
}

.flex_dt {
  flex-direction: column;
}

.al_c {
  align-items: center;
}

.ju_c {
  justify-content: center;
}

.ju_s {
  justify-content: space-between;
}

.ju_a {
  justify-content: space-around;
}

.ju_e {
  justify-content: space-evenly;
}
</style>
